export enum AccessLevel {
    READ = 'READ',
    WRITE = 'WRITE',
    ADMIN = 'ADMIN',
}
